<template>
  <div>
    <!-- We are adding overlay manually because v-nagigation-drawer was not adding it,
    and without this, drawer can't be closed with outside mouse click. -->
    <v-overlay v-model="drawer">
    </v-overlay>
    <v-navigation-drawer
      fixed
      app
      v-model="drawer"
      disable-resize-watcher
      class="side-nav"
    >
      <v-list>
        <v-list-item :to="{ name: 'landing' }">
          <v-list-item-header>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item-header>
        </v-list-item>
        <template v-for="item in menu">
          <v-list-item
            v-if="item.internal"
            :to="{ name: item.link }"
            :key="item.name"
          >
            <v-list-item-header>
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item-header>
          </v-list-item>
          <v-list-item v-else :href="'https://' + item.link" :key="item.name">
            <v-list-item-header>
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item-header>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar flat color="transparent" absolute>
    <v-container>
      <v-row align="center">
      <v-app-bar-nav-icon
        @click.stop="drawer = !drawer"
        class="hidden-md-and-up"
        alt="navigation drawer"
      ></v-app-bar-nav-icon>

      <router-link
        :to="{ name: 'landing' }"
        title="LipSurf Home"
        class="logo hidden-sm-and-down"
      ></router-link>

      <v-spacer></v-spacer>

      <div class="hidden-sm-and-down">
        <div class="d-flex flex-row">
          <template v-for="item in menu">
            <router-link
              class="nav-hor-a"
              v-if="item.internal"
              :key="item.name"
              :to="{ name: item.link }"
            >{{ item.name }}
            </router-link
            >
            <a
              class="nav-hor-a"
              v-else
              :key="item.name"
              :href="'https://' + item.link"
            >{{ item.name }}</a
            >
          </template>
        </div>
      </div>
      </v-row>
    </v-container>
    </v-app-bar>
    <!-- padded the size of the app-bar -->
    <v-main style="overflow-x: hidden; padding-top: 64px">
      <slot/>
      <slot name="outer"/>
    </v-main>
    <footer class="mute">
      <div class="links">
        <section>
          <div>
            <h5>Product</h5>
            <router-link
              :to="{ name: 'dragon' }"
              v-if="$route.name !== 'dragon'"
            >Comparison with Dragon NaturallySpeaking
            </router-link
            >
            <router-link
              :to="{ name: 'updates' }"
              v-if="$route.name !== 'updates'"
            >What's New
            </router-link
            >
            <router-link
              :to="{ name: 'enterprise' }"
              v-if="$route.name !== 'enterprise'"
            >Enterprise
            </router-link
            >
            <a href="https://help.lipsurf.com">Help</a>
            <router-link
              :to="{ name: 'pricing' }"
              v-if="$route.name !== 'pricing'"
            >Pricing
            </router-link
            >
          </div>
        </section>
        <section>
          <div>
            <h5>Developers</h5>
            <a href="https://blog.lipsurf.com">Documentation</a>
            <a href="https://github.com/lipsurf">Github</a>
            <a href="https://discuss.lipsurf.com/c/plugin-development"
            >Support</a
            >
          </div>
        </section>
        <section>
          <div>
            <h5>Company</h5>
            <a href="https://blog.lipsurf.com">Blog</a>
            <router-link :to="{ name: 'contact' }">Contact Us</router-link>
            <router-link :to="{ name: 'tos' }">Terms of Service</router-link>
            <router-link :to="{ name: 'privacy' }">Privacy</router-link>
          </div>
        </section>
      </div>
     <v-row class="mt-5">
       <v-col class="d-flex justify-center">
         <div class="mr-5">
           <a href="https://www.youtube.com/channel/UCdBYe2r5Sg9IjMFvn6I7KJw" target="_blank">
             <img :src="require('@/assets/img/youtube-icon.png')" loading="lazy" width="28" height="28" title="YouTube channel">
           </a>
         </div>
         <div class="mr-5">
           <a href="https://www.facebook.com/lipsurfapp/" target="_blank">
             <img :src="require('@/assets/img/fb-icon.png')" loading="lazy" width="28" height="28" title="Facebook page">
           </a>
         </div>
         <div class="mr-5">
           <a href="https://twitter.com/lipsurfapp" target="_blank">
             <img :src="require('@/assets/img/twitter-icon.png')" loading="lazy" width="28" height="28" title="Twitter account">
           </a>
         </div>
         <div>
           <a href="https://github.com/lipsurf" target="_blank">
             <img :src="require('@/assets/img/github-icon.png')" loading="lazy" width="28" height="28" title="Github account">
           </a>
         </div>
       </v-col>
      </v-row>
      <div style="margin: 2em">&copy; 2018-2026 LipSurf Inc.</div>
    </footer>
  </div>
</template>

<style>
.v-overlay {
  z-index: 50 !important;
}

.v-application a.bg-accent.v-btn {
  color: #e4f9fc;
}

.v-application a.v-btn.bg-accent:hover {
  color: #fff;
}

/* 1080 looks good but code on /enterprise page needs a bit more space to fit on one line */
.v-container.maxed {
  max-width: 1130px;
}

p {
  color: #333;
}

/* barlow-200 - latin */
@font-face {
  font-family: 'Barlow';
  font-style: normal;
  font-weight: 200;
  font-display: swap;
  src: url('@/assets/fonts/barlow-v11-latin-200.eot'); /* IE9 Compat Modes */
  src: local(''),
       url('@/assets/fonts/barlow-v11-latin-200.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
       url('@/assets/fonts/barlow-v11-latin-200.woff2') format('woff2'), /* Super Modern Browsers */
       url('@/assets/fonts/barlow-v11-latin-200.woff') format('woff'), /* Modern Browsers */
       url('@/assets/fonts/barlow-v11-latin-200.ttf') format('truetype'), /* Safari, Android, iOS */
       url('@/assets/fonts/barlow-v11-latin-200.svg#Barlow') format('svg'); /* Legacy iOS */
}

/* barlow-500 - latin */
@font-face {
  font-family: 'Barlow';
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: url('@/assets/fonts/barlow-v11-latin-500.eot'); /* IE9 Compat Modes */
  src: local(''),
       url('@/assets/fonts/barlow-v11-latin-500.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
       url('@/assets/fonts/barlow-v11-latin-500.woff2') format('woff2'), /* Super Modern Browsers */
       url('@/assets/fonts/barlow-v11-latin-500.woff') format('woff'), /* Modern Browsers */
       url('@/assets/fonts/barlow-v11-latin-500.ttf') format('truetype'), /* Safari, Android, iOS */
       url('@/assets/fonts/barlow-v11-latin-500.svg#Barlow') format('svg'); /* Legacy iOS */
}
</style>
<style scoped>
  .nav-hor-a {
    padding: 0.5em 1.5em;
    display: flex;
    align-items: center;
    font-weight: 500;
  }

  footer a {
    text-decoration: none;
  }

  footer .links {
    display: flex;
    flex-direction: row;
    justify-content: center;
    max-width: 900px;
    margin: 0 auto;
  }

  footer h5 {
    margin: 0;
  }

  footer .links section {
    margin: 0 2em;
  }

  footer .links section div {
    flex: 1;
    display: flex;
    text-align: left;
    flex-direction: column;
    margin: 2em auto;
  }

  .link--point::after {
    content: "";
    display: block;
    width: 3px;
    height: 3px;
    border-radius: 5px;
    background-color: #057f7f;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: -10px
  }

  @media (max-width: 600px) {
    footer .links {
      display: block;
    }
  }

  .side-nav {
    z-index: 60 !important;
  }
</style>

<script lang="ts" setup>
import { ref, } from 'vue'

let drawer = ref(false)
const menu = [
  { internal: true, link: 'updates', name: 'What\'s New' },
  { internal: true, link: 'pricing', name: 'Get Premium' },
  { internal: false, link: 'docs.lipsurf.com', name: 'Developers' },
  { internal: false, link: 'discuss.lipsurf.com', name: 'Forum' },
]
</script>

